module.exports = __webpack_public_path__ + "static/scheiben-desktop-eb51e91d9538d48fe1dbab1d50ced5f4.jpg";